/**
 * Toggle form button on guestbook page
 */
export function onGuestBookAddReviewClick(event) {
  event.preventDefault();
  const content = document.querySelector('.lg-guestbook .toggle__content');
  const contact = document.querySelector('#contact-guestbook');
  content.style.display = 'block';
  window.scrollTo({
    top: window.scrollY + contact.getBoundingClientRect().top - 120,
    behavior: 'smooth',
  });
}
